import { apiRoutes } from "@constants/api-routes";
import { handleRequest } from "@utils/http-util";
import { injectIdentityProviderId } from "@utils/parameter-injector";
import { RequestTypes } from "@enums/request-types";
import { IdentityProviderChangeRequestResponse } from "@idw-types/data/identity-providers";

type CreateIdentityProviderChangeRequestRequestResponse = {
    response: IdentityProviderChangeRequestResponse;
};

export const createIdentityProviderChangeRequestRequest = async (
    identityProviderId: string
): Promise<{ data: CreateIdentityProviderChangeRequestRequestResponse, error: any }> => {
    const route = injectIdentityProviderId(apiRoutes.idpConfiguration.identityProviderConfig.changeRequest.identityProvider.createChangeRequest, identityProviderId);
    const { data, error } = await handleRequest(RequestTypes.POST, route);
    return { data, error };
};